module.exports = __webpack_public_path__ + "img/student-exam.7d3f23ff.jpg";